export default "__VITE_ASSET__CI3MeK4z__"